import React from 'react'
import * as TerminateProjectByAdminType from './terminateProjectByAdminType'
import useTerminateProjectByAdmin from './useTerminateProjectByAdmin'

// --- MaterialUI --- //
import { Grid, makeStyles } from '@material-ui/core'

// --- FinalForm --- //
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

// --- Control --- //
import Dialog from '../../../../../../control/dialog/dialog'

// --- Share UI --- //
import EthicsForm from '../../../../shareUI/ethicsForm/ethicsForm'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import RemarkFromAdmin from '../../../../shareUI/remarkFromAdmin/remarkFromAdmin'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useSnackbarAction from '../../../../../../stores/snackbar/snackbarAction'

import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import useTranslate from '../../../../../../i18n/useTranslate'
import PageAction from '../../pageAction'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import ResearcherForm from '../../../../shareUI/researcherForm/researchForm'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

type ErrorsType = {
    langTH?: string
    langEN?: string
}

//View
const TerminateProjectByAdminView = (props: TerminateProjectByAdminType.TerminateProjectByAdminViewType) => {
    const {
        onClickSubmit,
        onClickCancel,
        onRefDialogTwo,
        configDialog,
        handleChangeFaculty,
        selectedIrb,
        // --- props from outer --- //
        btnClose,
        initialData = {},
        isViewMode = false,
        initialUploadFile = [],
        projectData,
        handleDirtyChange,
        onChangeResearcherType,
        valuesForm,
        formValueRef,
        checkUseUploadEdit,
    } = props
    //* STORE *//
    const manageProjectStore = useManageProjectStore()
    const snackbarAction = useSnackbarAction()
    const checkPermission = useCheckPermission()
    const isResearcher = checkPermission.isUserResearcher()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    const { documentTopic } = manageProjectStore

    const translate = useTranslate()
    const uploadFileinit = documentTopic?.map(() => {
        return {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
            },
        }
    })

    const isNotCompleteDocument = projectData?.submittedStatusInfo?.value === constSubmittedStatus.incorrectDocument
    const isDisableDoc = isViewMode && (!isNotCompleteDocument || !checkUseUploadEdit())

    return (
        <Form
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{
                ...initialData,
                uploadFile: initialUploadFile && initialUploadFile.length > 0 ? initialUploadFile : uploadFileinit,
                documentAdditionalInfo: projectData?.documentAdditionalInfo ?? [],
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!values.langTH && !values.langEN) {
                    errors.langTH = translate.get('MESSAGE.M016')

                    errors.langEN = translate.get('MESSAGE.M016')
                }

                return errors
            }}
        >
            {({ handleSubmit, form, dirty, invalid, errors, values }) => {
                valuesForm.current = values
                if (formValueRef) formValueRef.current = values
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            {projectData?.verifyDocument === false && (
                                <Grid item xs={12}>
                                    <RemarkFromAdmin
                                        isShow={projectData?.verifyDocument === false}
                                        projectData={projectData ?? undefined}
                                    />
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <EthicsForm
                                    callbackChangeFaculty={handleChangeFaculty}
                                    disabled={true} //{isViewMode || isApproveWithComment}
                                    isNotCompleteDocument={isNotCompleteDocument}
                                    isDisableRIB={true} //{isDisableIRB || isViewMode}
                                    isDisablePhase={true} //{isViewMode || isApproveWithComment}
                                    isDisableNumPhase={true} //{isViewMode || isApproveWithComment}
                                    callbackChangeResearcherType={onChangeResearcherType}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherForm disabled={true} />
                            </Grid>

                            {!isResearcher && (
                                <>
                                    <Grid item xs={12}>
                                        <UploadDoc
                                            documentTitleList={documentTopic}
                                            initialData={initialUploadFile}
                                            selectedIrb={selectedIrb}
                                            isViewMode={isDisableDoc && !canUpdateDocument}
                                            latestDocument={projectData?.latestDocument}
                                            required={false}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <UploadAdditionalDoc isViewMode={isDisableDoc && !canUpdateDocument} />
                                    </Grid>
                                </>
                            )}

                            {!btnClose || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>

                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const TerminateProjectByAdmin = (props: TerminateProjectByAdminType.TerminateProjectByAdminType) => {
    const terminateProjectByAdminModel = useTerminateProjectByAdmin(props)
    return <TerminateProjectByAdminView {...terminateProjectByAdminModel} {...props} />
}
export default TerminateProjectByAdmin
